// extracted by mini-css-extract-plugin
export default {"sticky":"vJP2Lk"};